// Country to currency mapping with exchange rates (USD base)
export const COUNTRY_CURRENCIES = {
  US: { code: 'USD', symbol: '$', rate: 1, name: 'United States Dollar' },
  NG: { code: 'NGN', symbol: '₦', rate: 1550, name: 'Nigerian Naira' },
  GB: { code: 'GBP', symbol: '£', rate: 0.79, name: 'British Pound' },
  CA: { code: 'CAD', symbol: 'CA$', rate: 1.36, name: 'Canadian Dollar' },
  AU: { code: 'AUD', symbol: 'A$', rate: 1.53, name: 'Australian Dollar' },
  EU: { code: 'EUR', symbol: '€', rate: 0.92, name: 'Euro' },
  DE: { code: 'EUR', symbol: '€', rate: 0.92, name: 'Euro' },
  FR: { code: 'EUR', symbol: '€', rate: 0.92, name: 'Euro' },
  IT: { code: 'EUR', symbol: '€', rate: 0.92, name: 'Euro' },
  ES: { code: 'EUR', symbol: '€', rate: 0.92, name: 'Euro' },
  NL: { code: 'EUR', symbol: '€', rate: 0.92, name: 'Euro' },
  IN: { code: 'INR', symbol: '₹', rate: 83.12, name: 'Indian Rupee' },
  JP: { code: 'JPY', symbol: '¥', rate: 151.5, name: 'Japanese Yen' },
  CN: { code: 'CNY', symbol: '¥', rate: 7.24, name: 'Chinese Yuan' },
  KR: { code: 'KRW', symbol: '₩', rate: 1340, name: 'South Korean Won' },
  BR: { code: 'BRL', symbol: 'R$', rate: 4.97, name: 'Brazilian Real' },
  MX: { code: 'MXN', symbol: 'MX$', rate: 17.15, name: 'Mexican Peso' },
  ZA: { code: 'ZAR', symbol: 'R', rate: 18.65, name: 'South African Rand' },
  GH: { code: 'GHS', symbol: 'GH₵', rate: 12.5, name: 'Ghanaian Cedi' },
  KE: { code: 'KES', symbol: 'KSh', rate: 153, name: 'Kenyan Shilling' },
  AE: { code: 'AED', symbol: 'د.إ', rate: 3.67, name: 'UAE Dirham' },
  SG: { code: 'SGD', symbol: 'S$', rate: 1.34, name: 'Singapore Dollar' },
  PH: { code: 'PHP', symbol: '₱', rate: 56.2, name: 'Philippine Peso' },
  PK: { code: 'PKR', symbol: '₨', rate: 278, name: 'Pakistani Rupee' },
  EG: { code: 'EGP', symbol: 'E£', rate: 30.9, name: 'Egyptian Pound' },
};

// Country names for display
export const COUNTRY_NAMES = {
  US: 'United States',
  NG: 'Nigeria',
  GB: 'United Kingdom',
  CA: 'Canada',
  AU: 'Australia',
  EU: 'European Union',
  DE: 'Germany',
  FR: 'France',
  IT: 'Italy',
  ES: 'Spain',
  NL: 'Netherlands',
  IN: 'India',
  JP: 'Japan',
  CN: 'China',
  KR: 'South Korea',
  BR: 'Brazil',
  MX: 'Mexico',
  ZA: 'South Africa',
  GH: 'Ghana',
  KE: 'Kenya',
  AE: 'United Arab Emirates',
  SG: 'Singapore',
  PH: 'Philippines',
  PK: 'Pakistan',
  EG: 'Egypt',
};

// Get currency info for a country code
export function getCurrencyForCountry(countryCode) {
  return COUNTRY_CURRENCIES[countryCode] || COUNTRY_CURRENCIES.US;
}

// Convert USD amount to local currency
export function convertToLocalCurrency(usdAmount, countryCode) {
  const currency = getCurrencyForCountry(countryCode);
  const localAmount = usdAmount * currency.rate;
  return {
    amount: localAmount,
    formatted: formatCurrency(localAmount, currency.code, currency.symbol),
    code: currency.code,
    symbol: currency.symbol,
  };
}

// Format currency with proper locale handling
export function formatCurrency(amount, currencyCode, symbol) {
  // For currencies with no decimals (JPY, KRW)
  const noDecimalCurrencies = ['JPY', 'KRW'];
  const decimals = noDecimalCurrencies.includes(currencyCode) ? 0 : 2;

  const formatted = amount.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return `${currencyCode} ${formatted}`;
}

// Check if country uses a different currency than USD
export function hasDifferentCurrency(countryCode) {
  if (!countryCode) return false;
  const currency = getCurrencyForCountry(countryCode);
  return currency.code !== 'USD';
}

// Parse USD string like "$1,240.50" to number
export function parseUSDString(usdString) {
  if (!usdString) return 0;
  // Remove $ and commas, then parse as float
  return parseFloat(usdString.replace(/[$,]/g, ''));
}

// Convert country name to country code
// Handles both codes ("NG") and full names ("NIGERIA", "Nigeria")
export function getCountryCode(value) {
  if (!value) return '';

  // If it's already a valid country code, return it
  if (COUNTRY_NAMES[value]) return value;

  // Try to find the code by country name (case-insensitive)
  const normalizedValue = value.trim().toLowerCase();
  const entry = Object.entries(COUNTRY_NAMES).find(
    ([, name]) => name.toLowerCase() === normalizedValue
  );

  return entry ? entry[0] : '';
}
